<div class="container-fluid">
    <div class="wpb_wrapper">
        <div class="vc_separator">
            <h4>
                <span>Terms and Conditions</span>
            </h4>
        </div>
        <div class="wpb_text_column wpb_content_element">
            <div class="wpb_wrapper">
                <p>
                    We at Mango Mist Resorts wish to make your outing / stay as relaxing and enjoyable as possible. We request you to please follow our rules and regulations mentioned below. We will do our best to remedy problems or concerns
                    you may have. If at any time you feel that something is not right, please feel free to contact the Manager. Below are the terms and conditions, please read them carefully and sign the disclaimer after accepting
                </p>
                <ol style="padding: 0;">
                    <li>
                        &nbsp;Registration:&nbsp;The guest registering should be 18 or above years of age, children to be accompanied by an adult at all times in the property. All facilities to be used only between check in and checkout timings
                        as per reservations.
                    </li>
                    <li>
                        Documentation: - A valid photocopy of my/our identity card with the proof of my residence / date of birth will be provided before check-in at registration counter. If I/we found guilty by the competent authority I/we
                        shall only be responsible and shall deal such proceedings on our own. If so then the management of the mango mist resort or any of their staff will not be responsible for any accidents / injury / loss of life. I / we
                        only will be responsible for such unfortunate incident.
                    </li>
                    <li>&nbsp;Participants: Participation&nbsp;is restricted to the registered guests only therefore we do not allow any visitors / drivers.</li>
                    <li>
                        Children :&nbsp; All children need to be supervised by a parent or guardian,&nbsp;as Mango Mist Resorts is not responsible for any damages , losses , injuries and accidents at all areas of the resort. Children aged 12
                        years and above will be charged at adult&nbsp;rates. Children may not be allowed to perform some activities as per age and difficulty, if allowed then a adventure declaration form to be signed by
                        the&nbsp;child&nbsp;parent or guardian
                    </li>
                    <li>&nbsp;&nbsp;Request you to please use the lockers if needed, as&nbsp;Mango Mist Resort is not responsible for any loss / damages of valuables during the rides.</li>
                    <li>
                        &nbsp;&nbsp;Adventure Activity Risk :&nbsp; We would like to inform you&nbsp;there may be&nbsp; a factor of risk involved&nbsp; therefore&nbsp; ride at your own risk ,&nbsp;Please note in case of any accidents Mango Mist
                        Resorts in not liable as you are taking part in the activities at your own will.&nbsp;&nbsp;If you posses any psychological or physical or medical&nbsp;limitation , or not willing to assume risk, or not confidant,&nbsp;
                        or not accepting the difficulty of adventure activities , or under the influence of alcohol ,&nbsp; please do NOT take part in the adventure activities.&nbsp;If so then the management of the mango mist resort or any of
                        their staff will not be responsible for any accidents / injury / loss of life.
                    </li>
                    <li>Adventure activities may get delay in start / postponed / cancelled due to safety issues may be due to rain / windy / even due to technical issues.</li>
                    <li>
                        CANCELLATIONS: An advance once paid will NOT be refunded under any circumstances. There are no adjustments for late arrivals or early departures. In the event of “No Shows” the customer will be charged the full amount of
                        the reserved time.
                    </li>
                    <li>
                        &nbsp;&nbsp;&nbsp;BREAKAGES / LOST Items: Any breakages / lost items related to the resort caused by guest occupants during their stay / day outing will be charged to their personal accountability and will be settled in
                        full ASAP or as and when guided by management. The amount to be charged is based on the price acquisition of such item(s) or the actual quote.
                    </li>
                    <li>&nbsp;LIABILITY: The management assumes no responsibility for accidents, injuries, or loss of property including theft, fire, flood, wind, or any act of God that may occur within the Resort.</li>
                    <li>&nbsp;&nbsp;Outdoor activities, registration counters are monitored / recorded by CCTV cameras for security reasons.</li>
                    <li>&nbsp;Photographs shot by our in-house photographer in the public areas, customers reviews may be shared on social media or website.</li>
                    <li>&nbsp;Since the resort is designed considering&nbsp;minimal modification of the natural landscape and&nbsp;nature by keeping it rustic and original, we request you to be careful on the uneven areas .</li>
                    <li>
                        &nbsp;Bar: We strictly do not allow registered guests to take part in the adventure rides under the influence of alcohol, we strongly recommend guests to take part in the adventure activities when in a sober state only.
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
<style>

    h4 {
		background: rgb(15, 36, 83);
		height: 1px;
		display: flex;
		align-items: center;
        justify-content: center;
		padding: 0;
		width: 100%;
        margin-bottom: 35px;
        font-size: 1em;;
	}
    
    .vc_separator {
        margin-top: 25px;
        display: block;
    }

    h4 span {
		padding: 0 15px;
		background: #fff;
    }

    p {
        color: #444;
        font-size: 1.125rem;
        line-height: 2rem;
        margin: 0 0 10px;
    }

    li {
        font-size: 1.125rem;
    }
</style>